import { render, staticRenderFns } from "./round.vue?vue&type=template&id=9c3585fc&scoped=true"
import script from "./round.vue?vue&type=script&lang=js"
export * from "./round.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c3585fc",
  null
  
)

export default component.exports